/* @ngInject */

export default () => {
  return function (_collection, _start) {
    var out = [];
    if (!_start || _start === '') {
      out = _collection;
    } else {
      var start = +parseInt(_start);
      out = _collection.slice(start);
    }
    return out;
  };
};
